/* Code console: wraps pre blocks in rich text and product descriptions with a header bar and Copy button */
(function () {
  var SELECTOR = '.rte pre, .product__description pre';

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (e) {
        reject(e);
      }
      document.body.removeChild(area);
    });
  }

  function getLabel(pre) {
    var label = pre.getAttribute('data-lang');
    if (!label) {
      var code = pre.querySelector('code');
      var match = code && code.className.match(/language-([\w.+-]+)/);
      label = match ? match[1] : '';
    }
    return label || 'code';
  }

  function enhance(pre) {
    if (pre.dataset.consoleReady) return;
    pre.dataset.consoleReady = '1';

    var wrap = document.createElement('div');
    wrap.className = 'code-console';

    var bar = document.createElement('div');
    bar.className = 'code-console__bar';
    for (var i = 0; i < 3; i++) {
      var dot = document.createElement('span');
      dot.className = 'code-console__dot';
      dot.setAttribute('aria-hidden', 'true');
      bar.appendChild(dot);
    }

    var label = document.createElement('span');
    label.className = 'code-console__label';
    label.textContent = getLabel(pre);
    bar.appendChild(label);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'code-console__copy';
    button.textContent = 'Copy';
    button.setAttribute('aria-live', 'polite');
    button.addEventListener('click', function () {
      var text = pre.innerText.replace(/\n+$/, '');
      copyText(text).then(function () {
        button.textContent = 'Copied';
        button.classList.add('is-copied');
        setTimeout(function () {
          button.textContent = 'Copy';
          button.classList.remove('is-copied');
        }, 1800);
      }, function () {
        button.textContent = 'Press Ctrl+C';
      });
    });
    bar.appendChild(button);

    pre.parentNode.insertBefore(wrap, pre);
    wrap.appendChild(bar);
    wrap.appendChild(pre);
  }

  function init(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

/* Battery limit: max 3 lithium batteries per order in total (postal regulations).
   To add a new battery product, add its variant ID to IDS.
   Covers: product page form, "Add this too" and any other add-to-cart form (checked before the theme
   sees the submit), quick add (fetch), and the cart page (checkout is locked while over the limit).
   "Buy it now" is hidden on battery pages because it skips the cart.
   Browser-level only: Shopify checkout itself is not capped. */
(function () {
  var IDS = ['67713965588713', '67714011103465', '67714041053417'];
  var MAX = 3;
  var MSG = 'Limit of 3 batteries per order in total, due to postal regulations for lithium batteries.';
  var nativeFetch = window.fetch.bind(window);
  var count = null;
  var timer;

  function isBattery(id) { return IDS.indexOf(String(id)) > -1; }

  function toast(text, sticky) {
    var el = document.getElementById('tt-batt-limit');
    clearTimeout(timer);
    if (!text) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('div');
      el.id = 'tt-batt-limit';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'position:fixed;left:1.6rem;right:1.6rem;bottom:1.6rem;max-width:44rem;z-index:99999;padding:1.2rem 1.6rem;border:2px solid #993556;border-radius:6px;background:#fde4ea;color:#0c1f23;font-size:1.4rem;line-height:1.4;box-shadow:0 4px 14px rgba(0,0,0,.25)';
      document.body.appendChild(el);
    }
    el.textContent = text;
    if (!sticky) timer = setTimeout(function () { toast(''); }, 7000);
  }

  function lock(over) {
    document.querySelectorAll('[name=checkout], #checkout, .cart__checkout-button').forEach(function (b) {
      b.disabled = over;
      b.style.opacity = over ? '.5' : '';
      b.style.pointerEvents = over ? 'none' : '';
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach(function (b) {
      b.style.display = over ? 'none' : '';
    });
  }

  function onCartPage() { return !!document.querySelector('main[data-template="cart"]'); }

  function refresh() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = 0;
        cart.items.forEach(function (i) { if (isBattery(i.variant_id)) n += i.quantity; });
        count = n;
        var over = n > MAX;
        if (over || onCartPage()) toast(over ? MSG + ' Please remove some batteries to check out.' : '', over);
        lock(over);
        return n;
      })
      .catch(function () { return count; });
  }

  function batteriesInForm(form) {
    var n = 0;
    try {
      var fd = new FormData(form);
      if (isBattery(fd.get('id'))) n += parseInt(fd.get('quantity') || '1', 10) || 1;
      fd.forEach(function (v, k) {
        var m = k.match(/^items\[(\d+)\]\[id\]$/);
        if (m && isBattery(v)) n += parseInt(fd.get('items[' + m[1] + '][quantity]') || '1', 10) || 1;
      });
    } catch (e) {}
    return n;
  }

  /* 1. Any add-to-cart form, caught before the theme's own handler runs. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var adding = batteriesInForm(form);
    if (!adding) return;
    if ((count || 0) + adding > MAX) {
      e.preventDefault();
      e.stopImmediatePropagation();
      toast(MSG + (count ? ' You already have ' + count + ' in your cart.' : ''));
      refresh();
    } else {
      setTimeout(refresh, 1500);
    }
  }, true);

  /* 2. Quick add and other scripted adds that use fetch. Installed after page load so other
     scripts that replace window.fetch cannot drop it. */
  function bodyBatteries(b) {
    var n = 0;
    try {
      if (typeof FormData !== 'undefined' && b instanceof FormData) {
        if (isBattery(b.get('id'))) n += parseInt(b.get('quantity') || '1', 10);
      } else if (typeof b === 'string') {
        if (b.charAt(0) === '{') {
          var j = JSON.parse(b);
          (j.items || [j]).forEach(function (it) { if (isBattery(it.id)) n += parseInt(it.quantity || 1, 10); });
        } else {
          var p = new URLSearchParams(b);
          if (isBattery(p.get('id'))) n += parseInt(p.get('quantity') || '1', 10);
        }
      }
    } catch (e) {}
    return n;
  }

  function wrapFetch() {
    var current = window.fetch;
    if (current && current.__ttBatt) return;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') > -1) {
        var adding = bodyBatteries(init && init.body);
        if (adding > 0) {
          return refresh().then(function (n) {
            if ((n || 0) + adding > MAX) {
              toast(MSG);
              return new Response(JSON.stringify({ status: 422, message: MSG, description: MSG }), { status: 422, headers: { 'Content-Type': 'application/json' } });
            }
            var res = current.apply(window, [input, init]);
            res.then(function () { setTimeout(refresh, 500); }, function () {});
            return res;
          });
        }
      }
      return current.apply(window, arguments);
    };
    wrapped.__ttBatt = true;
    window.fetch = wrapped;
  }
  window.addEventListener('load', function () { wrapFetch(); setTimeout(wrapFetch, 3000); });

  /* 3. Battery product pages: cap the quantity box and hide "Buy it now". */
  function guardProductPage() {
    var found = false;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !isBattery(idInput.value)) return;
      if (form.closest('.product-form, product-form, .product__info-container') || form.id.indexOf('product-form') === 0) found = true;
    });
    if (!found) return false;
    document.querySelectorAll('.product-form__quantity input[name="quantity"], quantity-input input').forEach(function (q) { q.max = MAX; });
    document.querySelectorAll('.shopify-payment-button').forEach(function (b) { b.style.display = 'none'; });
    return true;
  }

  function start() {
    var isProduct = guardProductPage();
    if (isProduct || onCartPage() || document.querySelector('cart-drawer')) refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 300); });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Touch me hint: starts the CMozGlow hint animation only when the simulator box is on screen (see .tt-glow__frame in code-console.css). */
(function () {
  function arm() {
    var frame = document.querySelector('.tt-glow__frame');
    if (!frame || frame.classList.contains('is-inview')) return;
    if (!('IntersectionObserver' in window)) {
      frame.classList.add('is-inview');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          frame.classList.add('is-inview');
          io.disconnect();
        }
      });
    }, { threshold: 0.4 });
    io.observe(frame);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();
